// extracted by mini-css-extract-plugin
module.exports = {"comments":"bk_fF","comments__list":"bk_fG"};